import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rawDataSection"]
  
  connect() {
    console.log("Receipt detail viewer connected successfully")
    // 키보드 이벤트 리스너 추가
    this.boundHandleKeyDown = this.handleKeyDown.bind(this)
    document.addEventListener('keydown', this.boundHandleKeyDown)
    
    // 컨트롤러가 연결되었는지 확인용
    window.receiptDetailViewer = this
  }
  
  disconnect() {
    console.log("Receipt detail viewer disconnected")
    // 키보드 이벤트 리스너 제거
    if (this.boundHandleKeyDown) {
      document.removeEventListener('keydown', this.boundHandleKeyDown)
    }
    
    // 윈도우 참조 제거
    if (window.receiptDetailViewer === this) {
      delete window.receiptDetailViewer
    }
  }
  
  handleKeyDown(event) {
    console.log("Key pressed:", event.key, "Meta:", event.metaKey, "Ctrl:", event.ctrlKey, "Shift:", event.shiftKey)
    
    // 모달이 현재 열려있는지 확인
    if (!this.element || !this.element.isConnected) {
      console.log("Element not connected")
      return
    }
    
    // D 키가 눌렸는지 확인 (대소문자 구분 없이)
    if ((event.key === 'D' || event.key === 'd') && 
        (event.metaKey || event.ctrlKey) && 
        event.shiftKey) {
      
      console.log("Raw data toggle shortcut detected!")
      event.preventDefault()
      event.stopPropagation()
      this.toggleRawData()
    }
  }
  
  toggleRawData() {
    console.log("Toggle raw data called")
    console.log("Has target:", this.hasRawDataSectionTarget)
    
    if (this.hasRawDataSectionTarget) {
      const section = this.rawDataSectionTarget
      const isHidden = section.classList.contains('hidden')
      
      console.log("Raw data section is currently hidden:", isHidden)
      
      if (isHidden) {
        section.classList.remove('hidden')
        console.log("✅ Showing raw data section")
      } else {
        section.classList.add('hidden')
        console.log("✅ Hiding raw data section")
      }
    } else {
      console.error("❌ Raw data section target not found!")
      console.log("Available targets:", this.targets)
    }
  }
  
  // 버튼 클릭용 메서드 (디버깅용)
  showRawData() {
    console.log("Show raw data method called")
    if (this.hasRawDataSectionTarget) {
      this.rawDataSectionTarget.classList.remove('hidden')
    }
  }
  
  hideRawData() {
    console.log("Hide raw data method called")
    if (this.hasRawDataSectionTarget) {
      this.rawDataSectionTarget.classList.add('hidden')
    }
  }
} 